(() => {
  const root = document.querySelector('[data-gg-delivery-config]');
  if (!root) return;

  // Config
  const SHEET_ID = root.dataset.sheetId;
  const ZONES_SHEET = root.dataset.zonesSheet || 'Zones';
  const POLICY_URL = root.dataset.policyUrl || '/policies/shipping-policy';
  const ZONES_URL = `https://docs.google.com/spreadsheets/d/${SHEET_ID}/gviz/tq?tqx=out:json&sheet=${encodeURIComponent(ZONES_SHEET)}`;

  // Elements
  const openBtn = document.getElementById('gg-delivery-open');
  const modal   = document.getElementById('gg-delivery-modal');
  const closeBtn= document.getElementById('gg-delivery-close');
  const input   = document.getElementById('gg-postal');
  const checkBtn= document.getElementById('gg-check');
  const result  = document.getElementById('gg-result');

  // State
  const DAYS = ["Mon","Tue","Wed","Thu","Fri","Sat","Sun"];
  const dayFull = {Mon:"Monday",Tue:"Tuesday",Wed:"Wednesday",Thu:"Thursday",Fri:"Friday",Sat:"Saturday",Sun:"Sunday"};
  const TZ = "America/Toronto";
  const LABELS = {
    service: "Doorstep Delivery Options",
    surcharge: "Early Late Surcharge",
    condo: "Delivery to Condo or Unit",
    cutoff: "Order cutoff",
    next: "Next delivery",
    zone: "Neighbourhood",
    notes: "Notes"
  };

  const byPC6 = new Map();      // exact 6-char postal code
  const byFSA = new Map();      // 3-char forward sortation area
  let fallbackRow = null;       // row where postal_code === "*"

  // Utils
  const slug = s => (s || "").toLowerCase().replace(/\s+/g, "_");
  const normalizePC = s => (s || "").toUpperCase().replace(/[^A-Z0-9]/g, "");
  const isFSA = s => /^[A-Z]\d[A-Z]$/.test(s);
  const isPC6 = s => /^[A-Z]\d[A-Z]\d[A-Z]\d$/.test(s);
  const truthy = v => /^(true|1|yes)$/i.test(String(v || "").trim());

  const splitDays = str => (str || "")
    .split(/[,\|\/\s]+/)
    .map(s => s.trim().slice(0,3))
    .filter(d => DAYS.includes(d));

  const ordinal = n => {
    const s = ["th","st","nd","rd"], v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };

  function nextDates(shortDays, howMany = 1) {
    const now = new Date();
    const parts = new Intl.DateTimeFormat("en-CA", {
      timeZone: TZ,
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    }).formatToParts(now);

    const y = +parts.find(p => p.type === "year").value;
    const m = +parts.find(p => p.type === "month").value;
    const d = +parts.find(p => p.type === "day").value;

    let cur = new Date(y, m - 1, d, 12, 0, 0);
    const names = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
    const out = [];

    for (let i = 0; i < 21 && out.length < howMany; i++) {
      const short = names[cur.getDay()];
      if (shortDays.includes(short)) {
        const p = new Intl.DateTimeFormat("en-CA", {
          timeZone: TZ,
          weekday: "long",
          month: "long",
          day: "numeric"
        }).formatToParts(cur);

        const wd = p.find(x => x.type === "weekday")?.value || "";
        const mo = p.find(x => x.type === "month")?.value || "";
        const dn = +(p.find(x => x.type === "day")?.value || 0);
        out.push(`${wd}, ${mo} ${ordinal(dn)}`);
      }
      cur.setDate(cur.getDate() + 1);
    }
    return out;
  }

  function parseGviz(text) {
    const start = text.indexOf("{");
    const end = text.lastIndexOf("}");
    const obj = JSON.parse(text.slice(start, end + 1));
    const cols = obj.table.cols.map(c => (c.label || c.id || "").toString().trim());
    const rows = [];

    (obj.table.rows || []).forEach(r => {
      const o = {};
      (r.c || []).forEach((cell, i) => {
        o[slug(cols[i])] = cell ? (cell.v ?? "").toString().trim() : "";
      });
      rows.push(o);
    });

    return rows;
  }

  function shippingMessageFrom(row) {
    const txt = row?.shipping_message;
    return (typeof txt === "string" && txt.trim() !== "")
      ? txt.trim()
      : "Shipping with Canada Post or Purolator may be possible.";
  }

  function renderShippingFallback(matchCode, fb) {
    const msg = shippingMessageFrom(fb);
    const cutoff = fb?.order_cutoff_hhmm || "10:00";
    result.style.display = "block";
    result.innerHTML = `
      <div class="gg-ship">
        <h4><span class="gg-bad">No local delivery</span> for <strong>${matchCode}</strong></h4>
        <div>${msg}</div>
        <div class="gg-delivery__kv" style="margin-top:.4rem">
          <div class="gg-delivery__muted">Order cutoff</div><div>${cutoff}</div>
        </div>
        <div style="margin-top:.5rem;display:flex;gap:.5rem;flex-wrap:wrap">
          <a class="gg-delivery__go" href="${POLICY_URL}">Shipping policy</a>
          <a class="gg-delivery__go" href="/collections/all">Start shopping</a>
        </div>
      </div>
    `;
  }

  function formatCutoff(raw) {
    const v = (raw || "").toString().trim();
    const m = /^Date\(\d+,\d+,\d+,(\d+),(\d+)/.exec(v);
    if (m) {
      const hh = String(+m[1]).padStart(2, "0");
      const mm = String(+m[2]).padStart(2, "0");
      return `${hh}:${mm}`;
    }
    return v || "—";
  }

  function renderResult(rec, matchCode) {
    if (!rec || truthy(rec.ship_only)) return renderShippingFallback(matchCode, rec || fallbackRow);

    const days = splitDays(rec.delivery_days);
    const next = nextDates(days, 1);
    const zone = rec.zone_name || "—";
    const cutoff = formatCutoff(rec.order_cutoff_hhmm);
    const service = rec.service_options || "Flexible";
    const condoYes = truthy(rec.condo_unit_allowed);
    const condoLine = condoYes ? `Yes${rec.condo_unit_note ? ", " + rec.condo_unit_note : ""}` : "No";
    const surcharge = rec.early_late_surcharge ? `$${Number(rec.early_late_surcharge).toFixed(2)}` : "—";
    const notes = rec.notes || "";

    result.style.display = "block";
    result.innerHTML = `
      <div style="font-size:1rem;margin-bottom:.2rem">
        <strong>${matchCode}</strong>: We deliver on <strong>${days.map(d => dayFull[d]).join(" & ") || "—"}</strong>
      </div>
      <div class="gg-delivery__kv">
        <div class="gg-delivery__muted">${LABELS.next}</div><div>${next[0] || "—"}</div>
        <div class="gg-delivery__muted">${LABELS.zone}</div><div>${zone}</div>
        <div class="gg-delivery__muted">${LABELS.cutoff}</div><div>${cutoff}</div>
        <div class="gg-delivery__muted">${LABELS.service}</div><div>${service}</div>
        <div class="gg-delivery__muted">${LABELS.surcharge}</div><div>${surcharge}</div>
        <div class="gg-delivery__muted">${LABELS.condo}</div><div>${condoLine}</div>
        ${notes ? `<div class="gg-delivery__muted">${LABELS.notes}</div><div>${notes}</div>` : ""}
      </div>
    `;
  }

  function lookupRecord(postal) {
    const normalized = normalizePC(postal);
    const pc6 = normalized.slice(0, 6);
    const fsa = normalized.slice(0, 3);

    // 1. Exact 6-character match first
    if (isPC6(pc6) && byPC6.has(pc6)) {
      return { matchCode: pc6, record: byPC6.get(pc6) };
    }

    // 2. Then try the 3-character FSA
    if (isFSA(fsa) && byFSA.has(fsa)) {
      return { matchCode: fsa, record: byFSA.get(fsa) };
    }

    // 3. Fallback
    return { matchCode: pc6 || fsa || postal, record: fallbackRow };
  }

  async function loadData() {
    const zonesTxt = await fetch(ZONES_URL).then(r => r.text());
    const rows = parseGviz(zonesTxt);

    byPC6.clear();
    byFSA.clear();
    fallbackRow = null;

    rows.forEach(r => {
      const raw = normalizePC(r.postal_code || r.fsa || "");

      if (raw === "*") {
        fallbackRow = r;
        return;
      }

      if (isPC6(raw)) {
        byPC6.set(raw, r);
        return;
      }

      if (isFSA(raw)) {
        byFSA.set(raw, r);
      }
    });
  }

  // UI
  function openModal() {
    modal.hidden = false;
    result.style.display = "none";
    setTimeout(() => input?.focus(), 0);
    document.body.style.overflow = "hidden";
  }

  function closeModal() {
    modal.hidden = true;
    document.body.style.overflow = "";
    openBtn?.focus();
  }

  openBtn?.addEventListener("click", openModal);
  closeBtn?.addEventListener("click", closeModal);
  modal?.addEventListener("click", e => {
    if (e.target === modal) closeModal();
  });
  document.addEventListener("keydown", e => {
    if (!modal.hidden && e.key === "Escape") closeModal();
  });

  function handleCheck() {
    const val = input.value;
    const res = lookupRecord(val);
    renderResult(res.record, res.matchCode);
  }

  checkBtn?.addEventListener("click", handleCheck);
  input?.addEventListener("keydown", e => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleCheck();
    }
  });

  loadData().catch(err => console.error("Delivery widget load failed:", err));
})();